import src from '../assets/mettle.png';
import { imageLogo } from './imageLogo';

export const MettleLogo = imageLogo({
  src,
  width: 480,
  height: 356,
  alt: 'Mettle Golf',
});
